import { FlexRow } from '@/components/common/Flex';
import { Center, FlexProps, Spinner } from '@chakra-ui/react';
import {
    assetsFromFEs,
    debtsFromFEs,
    useFinancialEntitiesContext,
} from '@common/react/financialEntities';
import { Button } from '../common/Button';
import { FlexCol } from '../common/Flex';
import BasicModalLayout from '../common/modals/BasicModalLayout';
import AddedAccounts from './AddedAccounts';

export interface ManualAddSharingViewProps extends FlexProps {
    activePartnershipId: string;
    financialEntityId?: string;
    onNext: VoidFunction;
}

const ManualAddSharingView = ({
    activePartnershipId,
    financialEntityId,
    onNext,
    ...props
}: ManualAddSharingViewProps) => {
    const fe = useAccount({ financialEntityId });

    return (
        <BasicModalLayout
            title={'How do you want to share this account?'}
            content={
                fe ? (
                    <FlexCol w="full">
                        <AddedAccounts
                            activePartnershipId={activePartnershipId}
                            accounts={[fe]}
                        />
                    </FlexCol>
                ) : (
                    <Center w="full">
                        <Spinner />
                    </Center>
                )
            }
            footer={
                <FlexRow w="full" justifyContent="flex-end" mt={8}>
                    <Button
                        onClick={() => onNext()}
                        onClickEvent="Confirm Manual Add Sharing Button Clicked"
                    >
                        Looks good
                    </Button>
                </FlexRow>
            }
            {...props}
        />
    );
};

const useAccount = ({ financialEntityId }: { financialEntityId?: string }) => {
    const { fes } = useFinancialEntitiesContext();

    // Use unfiltered data in this specific context to allow member
    // the opportunity to decide sharing permissions for *all* added FEs.
    if (!fes.unfilteredData) return null;
    const assets = assetsFromFEs(fes.unfilteredData.financialEntities);
    const debts = debtsFromFEs(fes.unfilteredData.financialEntities);
    return [...assets, ...debts].find(({ id }) => financialEntityId === id);
};

export default ManualAddSharingView;
